import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { offerPositionSchema, defaultOfferPosition } from './offerPositionSchema';

/**
 * Validation schema for request creation form
 * Includes client phones, operator phone, description, and offer positions
 */
export const requestCreateSchema = z.object({
    clientPhones: z.string().optional(),
    operatorPhone: z
        .string()
        .min(1, 'Operator phone is required')
        .refine(
            (value) => {
                try {
                    return isValidPhoneNumber(value);
                } catch {
                    return false;
                }
            },
            'Invalid phone number'
        ),
    description: z.string().optional(),
    carDocument: z.array(z.custom<File>()).optional(),
    offerPositions: z.array(offerPositionSchema).min(1, 'At least one offer position is required'),
});

export type RequestCreateFormData = z.infer<typeof requestCreateSchema>;

/**
 * Default values for request creation form
 */
export const defaultRequestFormValues: RequestCreateFormData = {
    clientPhones: '',
    operatorPhone: '',
    description: '',
    carDocument: [],
    offerPositions: [defaultOfferPosition],
};

